import { MutationTree } from 'vuex';
import { PhotoState, PhotoMutation } from './types';

export const mutations: MutationTree<PhotoState> = {
  SET_PHOTOS_FOR_CAMERA(state: PhotoState, { cameraId, photos, projectId }) {
    // On met à jour le projectId si nécessaire
    if (projectId) {
      state.projectId = projectId;
    }
    state.photosByCameraId = {
      ...state.photosByCameraId,
      [cameraId]: photos,
    };
    state.isLoading = false;
  },

  loading(state: PhotoState) {
    state.isLoading = true;
    // On ne vide plus `photosByCameraId` ici, car on peut charger des photos pour une autre caméra sans tout effacer
    // S'il est nécessaire de vider pour une caméra spécifique, faites-le dans l'action.
  },

  notLoading(state: PhotoState) {
    state.isLoading = false;
  },
};
